import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { explainSimDriver, SimExplainStats } from '../services/api';
import { AISummaryPanel } from './AISummaryPanel';

interface SimDriverExplanationProps {
  site: string;
  asOf: string;
  driver: string;
  stats: SimExplainStats;
  excludeTracks: string[];
}

/** "Why this number": a short AI explanation of a driver's simulation rating, shown in the driver modal. */
export const SimDriverExplanation: React.FC<SimDriverExplanationProps> = ({ site, asOf, driver, stats, excludeTracks }) => {
  const { data, isFetching, error, refetch } = useQuery<{ explanation: string }, Error>({
    queryKey: ['simExplain', site, asOf, driver, excludeTracks.join('|'), stats.winProb, stats.avgFinish],
    queryFn: () => explainSimDriver(site, asOf, driver, stats, excludeTracks),
    staleTime: Infinity,
    retry: false,
  });

  return (
    <AISummaryPanel
      label="Why this rating (AI summary of the races below)"
      isLoading={isFetching && !data}
      error={error}
      text={data?.explanation}
      onRetry={() => refetch()}
      sx={{ mt: 1.5, p: 1.5, borderRadius: 1 }}
    />
  );
};
